function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.37258 5.37258 0 12 0H26C32.6274 0 38 5.37258 38 12V26C38 32.6274 32.6274 38 26 38H12C5.37258 38 0 32.6274 0 26V12Z",
  fill: "#EFFAF1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26 14H20L18 12H12C11.45 12 11 12.45 11 13V25C11 25.55 11.45 26 12 26H26C26.55 26 27 25.55 27 25V15C27 14.45 26.55 14 26 14ZM21.5 16.75C22.47 16.75 23.25 17.53 23.25 18.5C23.25 19.47 22.47 20.25 21.5 20.25C20.53 20.25 19.75 19.47 19.75 18.5C19.75 17.53 20.53 16.75 21.5 16.75ZM25 24H18V22.75C18 21.58 20.33 21 21.5 21C22.67 21 25 21.58 25 22.75V24Z",
  fill: "#62CA76"
});

function SvgChangeEventPostFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeEventPostFaq);
export default __webpack_public_path__ + "static/media/change_event_post_faq.04a89700.svg";
export { ForwardRef as ReactComponent };